import {confettiOnContainer} from '../../../lib/confetti'

const REWARD_CONFIRMATION_EVENT = 'promotion.manual-claim.success'

export default (Bus) => {
  Bus.$on(REWARD_CONFIRMATION_EVENT, async (data, id, getVm) => {
    const vm = getVm()
    await vm.$nextTick()
    await vm.$nextTick()
    confettiOnContainer(vm.$el)
  })
}
